import { render, staticRenderFns } from "./extensionSurvey.vue?vue&type=template&id=7bec35f7&"
import script from "./extensionSurvey.vue?vue&type=script&lang=js&"
export * from "./extensionSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports